import { render, staticRenderFns } from "./GradeList.vue?vue&type=template&id=96326356&scoped=true"
import script from "./GradeList.vue?vue&type=script&lang=js"
export * from "./GradeList.vue?vue&type=script&lang=js"
import style0 from "./GradeList.vue?vue&type=style&index=0&id=96326356&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96326356",
  null
  
)

export default component.exports